// extracted by mini-css-extract-plugin
export default {"cls1":"D7s9sPeBcuz5BJbSae99","cls2":"WINy4NSiniM5mShyvKrx D7s9sPeBcuz5BJbSae99"};